/**
 * TTB hero — reveal text/button when fonts are ready (or after timeout).
 */
(function () {
  var section = document.querySelector('.TheTymewearTopBanner.TTB');
  if (!section) return;
  var MAX_WAIT = 5000;
  var revealed = false;
  function reveal() {
    if (revealed) return;
    revealed = true;
    section.classList.add('ttb-fonts-ready');
  }

  if (document.fonts && document.fonts.load) {
    var timer = setTimeout(reveal, MAX_WAIT);
    Promise.all([
      document.fonts.load('300 24px Inter'),
      document.fonts.load('300 53px "KMR-Apparat"'),
    ])
      .then(function () {
        clearTimeout(timer);
        reveal();
      })
      .catch(reveal);
  } else {
    setTimeout(reveal, 300);
  }
})();
